import { useState, useEffect } from 'react';
import { auth, onAuthStateChanged } from '../firebase';
import axios from 'axios';
import i18n from '../i18n';

const useDriverAccount = () => {
  const [loading, setLoading] = useState(true);
  const [driverAccount, setDriverAccount] = useState(null);
  const [error, setError] = useState(null);
  const [hasInvoiceData, setHasInvoiceData] = useState(true);
  const [isFirstLogin, setIsFirstLogin] = useState(false);

  const fetchDriverAccount = async () => {
    const user = auth.currentUser;
    if (!user) {
      setError('No authenticated user');
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const idToken = await user.getIdToken(true);
      const response = await axios.get(
        'https://api.servicegest.ro/driver/getDriverAccount',
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        }
      );
        console.log('Driver account response:', response.data);
      if (response.data) {
        setDriverAccount(response.data);
        setIsFirstLogin(response.data.firstLogin || false);

        // Set Romanian as default language for new driver accounts
        if (response.data.firstLogin && !localStorage.getItem('i18nextLng')) {
          i18n.changeLanguage('ro');
        }

        // Check if invoice data is complete
        const invoiceData = response.data.invoiceData;
        const hasCompleteInvoiceData =
          invoiceData &&
          invoiceData.city &&
          invoiceData.address &&
          invoiceData.country_code &&
          invoiceData.subdivision_code;

        setHasInvoiceData(hasCompleteInvoiceData);
      }
    } catch (err) {
      console.error('Error fetching driver account:', err);
      setError(err.message || 'Failed to fetch driver account');
      setDriverAccount(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setDriverAccount(null);
        setError(null);
        setLoading(false);
        return;
      }

      await fetchDriverAccount();
    });

    return () => unsubscribeAuth();
  }, []);

  const refreshDriverAccount = async () => {
    await fetchDriverAccount();
  };

  return {
    driverAccount,
    loading,
    error,
    hasInvoiceData,
    isFirstLogin,
    refreshDriverAccount,
  };
};

export default useDriverAccount;
